import { render, staticRenderFns } from "./Pollpage.vue?vue&type=template&id=7ed35c89"
import script from "./Pollpage.vue?vue&type=script&lang=js"
export * from "./Pollpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports